// extracted by mini-css-extract-plugin
module.exports = {"divider":"Modal_divider__1hTYw","Modal":"Modal_Modal__32mLz","ModalContainer":"Modal_ModalContainer__1j3Ma","close":"Modal_close__2EfR5"};